import { inferPagingFromApiResponse } from '~/core/api/helpers'

export default function ({ responseData, defaultPageSize = 25 } = {}) {
  let count, currentPage, perPage
  if (responseData)
    ({ count, currentPage, perPage } = inferPagingFromApiResponse(responseData))
  currentPage = currentPage || 1
  perPage = perPage || +defaultPageSize
  return {
    count,
    currentPage,
    perPage,
    totalPages: Math.ceil(count / perPage),
  }
}
